import React, { useMemo } from "react";
import styles from "./index.module.scss";
import { AvailableGiftCardItem, GIFT_CARD_STATUS } from "../../../../constants";
import classNames from "classnames";
import copy from "copy-to-clipboard";
import { sendMessageToParent } from "../../../../utils";

interface GiftCardItemProps {
  data: IGiftCardItem;
  availableGiftCards: AvailableGiftCardItem[];
}

export interface IGiftCardItem {
  create_time: string;
  current_value: number;
  id: number;
  initial_value: number;
  shopify_customer_id: number;
  shopify_gift_card_code: string;
  shopify_gift_card_id: number;
  source_type: number;
  status: number;
  update_time: string;
}

const GiftCardItem: React.FC<GiftCardItemProps> = ({
  data,
  availableGiftCards,
}) => {
  const isGiftCardAvailable = useMemo(() => {
    return data.status === GIFT_CARD_STATUS.AVAILABLE && data.current_value > 0;
  }, [data.status, data.current_value]);

  const handleCopy = () => {
    if (isGiftCardAvailable) {
      const isCopied = copy(data.shopify_gift_card_code, {
        debug: false,
        format: "text/plain",
      });

      isCopied &&
        sendMessageToParent({
          type: "member-toast",
          data: {
            type: "success",
            message: "Paste the code at the checkout to use",
            duration: 3000,
          },
        });
    } else {
      sendMessageToParent({
        type: "member-toast",
        data: {
          type: "error",
          message: "Gift card used",
          duration: 3000,
        },
      });
    }
  };

  const card = useMemo(() => {
    return availableGiftCards.find((card) => card.value === data.initial_value);
  }, [availableGiftCards, data.initial_value]);

  return (
    <div key={data.id} className={styles.giftCardItem}>
      <div className={styles.giftCardLabel}>
        <span>Gift Card</span>
      </div>
      <div className={styles.giftCardContent}>
        <div className={styles.leftSection}>
          <div className={styles.amount}>{card?.amountText}</div>
          <div
            className={styles.points}
          >{`Redeemed By ${card?.points} points`}</div>
          <div className={styles.codes}>Code:{data.shopify_gift_card_code}</div>
        </div>
        <div className={styles.rightSection}>
          <button
            data-element-id={`copy-gift-card-code`}
            className={classNames(styles.copyButton, {
              [styles.disabled]: !isGiftCardAvailable,
            })}
            onClick={handleCopy}
          >
            Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export default GiftCardItem;
